import { dateShortOut } from 'Data/format.js'
import { date } from 'Data/validate.js'
import { useDataChange } from 'Simple/Data.js'

export function useOnChange(props) {
  let change = useDataChange({
    context: 'claim',
    path: 'due_date',
    viewPath: props.viewPath,
  })

  return function onChange(_, date) {
    change(formatOutDate(date))

    if (typeof props.closePopover === 'function') {
      props.closePopover()
    }
  }
}

export function formatOutDate(value) {
  let length = value.split('/')?.[2]?.length
  if (!length) return value

  let formatted = dateShortOut(value)
  let isValid = date(formatted)
  return length !== 4 || !isValid ? value : formatted
}
